import { useContext, useEffect, useRef } from 'react';
import NotificationContext from '../../components/notifications/NotificationContext';
import { Toast } from '../../components/notifications/StatNotification';

const useToast = (): { toasts: Toast[]; createToast: (toastItem: Toast) => void } => {
  const { toasts, setToasts } = useContext(NotificationContext);
  const toastRef = useRef(toasts);
  toastRef.current = toasts;

  useEffect(() => {
    const exiting = toasts?.find((t) => t?.className === 'ms-motion-slideUpOut');
    if (exiting) {
      const removeToast = setTimeout(() => {
        setToasts(toastRef.current.filter((t) => t.id !== exiting.id));
      }, 100);
      return () => clearTimeout(removeToast);
    }
    return () => {};
  }, [toasts]);

  const createToast = (toastItem: Toast) => {
    if (toasts.length >= 3) return;

    setToasts([...toasts, toastItem]);

    setTimeout(() => {
      const next = toastRef.current.map((toast) =>
        toast.id === toastItem.id ? { ...toast, className: 'ms-motion-slideUpOut' } : toast,
      );
      setToasts(next);
    }, 14000);
  };

  return { toasts, createToast };
};

export default useToast;
